import { IonText, isPlatform } from '@ionic/react';

// Simulate the appearance of the stacked label rendered by a <Field>
export const FieldLabel: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const fontSize = isPlatform('android') ? 12 : 14;
    return (
        <IonText color="medium" style={{fontSize}}>
            {children}
        </IonText>
    );
};
